import { type FC } from 'react';
import { Controller } from 'react-hook-form';
import { RadioGroup } from '../../../../components/RadioGroup';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import { getFlagFromStatus, getStatusByFlag } from '../../../../types/boolean-flag';
import type {
  StripeConfigurationControl,
  StripeConfigurationFormValues,
} from '../../StripeConfigurationFormSchema';
import { AUTOMATICALLY_SYNC_INVOICES_OPTIONS } from './constants';

type InvoicesConfigurationSectionProps = {
  control: StripeConfigurationControl;
  defaultValues: StripeConfigurationFormValues;
};

export const InvoicesConfigurationSection: FC<InvoicesConfigurationSectionProps> = ({
  control,
  defaultValues,
}) => (
  <ConfigurationSection title="Invoices" iconName="InvoiceListItem">
    <Controller
      name="syncApprovedInvoices"
      control={control}
      defaultValue={defaultValues.syncApprovedInvoices}
      render={({ field: { value, onChange } }) => (
        <RadioGroup
          title="Choose how to sync approved invoices"
          value={getFlagFromStatus(value)}
          onChange={(selected) => onChange(getStatusByFlag(selected))}
          keyExtractor={(option) => option.value}
          options={AUTOMATICALLY_SYNC_INVOICES_OPTIONS}
        />
      )}
    />
  </ConfigurationSection>
);
